import { QUERY_KEYS } from '../../../../../consts';
import { getAtomWithMutation } from '../../../../../utils';
import { getIsQuoteAudioListenedService } from '../../../../../services';

export const getIsQuoteAudioListenedAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.GET_IS_QUOTE_AUDIO_LISTENED,
  mutationFn: () => getIsQuoteAudioListenedService,
});
